import React, { PureComponent } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import css from './index.scss';

class CourseBadgeAdmin extends PureComponent {
    render() {
        const { children, background, disabled } = this.props;
        const childElement = children ? (<div className={css.children}>{children}</div>) : '';
        const badgeStyle = disabled ? `${css.container} ${css.disabled}` : `${css.container}`;

        return (<div className={`${badgeStyle} ${background}`}>
            {childElement}
        </div>);
    }
}

CourseBadgeAdmin.propTypes = {
    children: PropTypes.node,
    background: PropTypes.string,
    disabled: PropTypes.bool
};

export default injectIntl(styleable(css)(CourseBadgeAdmin));




// WEBPACK FOOTER //
// ./app/components/course-badge-admin/course-badge-admin.js